var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg220Mall1Volt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 6,
    fill: "#D991DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2676 47.1757C55.7111 38.7322 55.7111 25.0628 47.2676 16.6409",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.733 16.6409C8.28952 25.0844 8.28952 38.7538 16.733 47.1757",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 52.2285C27.1837 53.0275 29.5806 53.4163 31.9992 53.4163C34.4178 53.3947 36.8148 53.0275 39.1254 52.2285",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 11.5877C27.1837 10.7887 29.5806 10.3999 31.9992 10.3999C34.4178 10.3999 36.8148 10.7887 39.1254 11.5877",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2223 18.1519H44.9824V24.6313C44.9824 26.1432 45.7953 26.4492 46.7868 25.3153L53.5486 17.5759C54.3793 16.631 54.0309 15.8481 52.7714 15.8481H50.0113V9.36867C50.0113 7.8568 49.1985 7.55083 48.207 8.68473L41.4452 16.424C40.6234 17.378 40.9718 18.1519 42.2223 18.1519Z",
    fill: "#F7E237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5329 39V25.8L27.3929 26.74H23.3729V25H28.5129V39H26.5329ZM35.2152 39L30.5752 28.4H32.5752L36.6952 38H35.7352L39.9352 28.4H41.8152L37.1752 39H35.2152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg220Mall1Volt);
export default __webpack_public_path__ + "static/media/220mall_1volt.dcf11498c6bdae880daecde47caf886f.svg";
export { ForwardRef as ReactComponent };